// Ledger amounts carry scale 4; comparing in minor units keeps a decimal
// difference like 15000.1 - 10000.3 free of float drift.
const SCALE = 10000

const toMinor = (value: string): number | null => {
  const parsed = parseFloat(value)
  return isNaN(parsed) ? null : Math.round(parsed * SCALE)
}

/**
 * How far below zero the available balance ends up after withdrawing `amount`,
 * formatted like the balance card (2 decimals), or null when the withdrawal
 * stays within the balance or either value is unknown.
 */
export const overdraftAfterWithdraw = (
  availableBalance: string | undefined,
  amount: string
): string | null => {
  if (availableBalance == null || availableBalance === '') return null
  const available = toMinor(availableBalance)
  const debit = toMinor(amount)
  if (available === null || debit === null || debit <= 0) return null

  const shortfall = debit - available
  return shortfall > 0 ? (shortfall / SCALE).toFixed(2) : null
}
